import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import queryString from 'query-string';
import { Container } from 'reactstrap';

import {
  ASSIGN_CHAUFFEUR_EMPTY,
  ASSIGN_VENDOR_EMPTY,
  BOOKING_ASSIGN_TO_ME_EMPTY,
  BULK_CONFIRM_BOOKING_BY_VENDOR_EMPTY,
  CANCEL_BOOKING_BY_ADMIN_EMPTY,
  CANCEL_BOOKING_BY_VENDOR_EMPTY,
  COMPLETE_BOOKING_EMPTY,
  CONFIRM_BOOKING_BY_VENDOR_EMPTY,
  GET_BOOKING_DETAILS,
  GET_BOOKING_DETAILS_EMPTY,
  GET_BOOKING_TYPE_FOR_GLOBAL_SEARCH,
  GET_BOOKINGS_LIST,
  GET_CARD_SUMMARY,
  GET_DASHBOARD_CONFIGURATION,
  REJECT_SLOT_EMPTY,
  SEND_NOTIFICATION_EMPTY,
} from '../../../../store/actions';
import { Loader } from '../../../Common';
import BreadcrumbTrail from '../../../Common/BreadcrumbTrail';
import { Constant } from '../../../Helpers/constant';
import StatusFilter from '../Bookings/Components/Filter/StatusFilter';
import AirportTransferActionablesModals from '../Bookings/Components/Modals/AirportTransfer';
import GolfActionableModals from '../Bookings/Components/Modals/Golf';
import Summary from '../Bookings/Components/Summary';
import DataViews from '../Bookings/Components/Views';

const Notification = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const { skip = 1, limit = Constant.TABLE_PAGE_SIZE, appliedName = '', appliedType = '' } = queryString.parse(location.search);

  /* ---------------------------- LOCAL STATES ---------------------------- */
  const [currentPageNumber, setCurrentPageNumber] = useState(Number(skip) - 1);
  const [rowsPerPage, setRowsPerPage] = useState(Number(limit));

  const [loading, setLoading] = useState(false);
  const [currentActiveBookingAction, setCurrentActiveBookingAction] = useState(null);

  const [currentSelectedBooking, setCurrentSelectedBooking] = useState(null);
  const [workflowStateFilters, setWorkflowStateFilters] = useState([]);
  const [workflowDisplayName, setWorkflowDisplayName] = useState(``);
  const [shouldHaveClearSelection, setShouldHaveClearSelection] = useState(false);
  const [secondaryFiltersList, setSecondaryFiltersList] = useState(null);
  const [assignedToMeFilter, setAssignedToMeFilter] = useState(false);
  const [isMultiSelectable, setIsMultiSelectable] = useState(false);

  /* ---------------------------- REDUX STATES ---------------------------- */
  const {
    bookingsList,
    bookingsListLoading,
    bookingDetails,
    bookingDetailsLoading,
    bookingTypeData,
    bookingTypeLoading,
    getDashboardConfiguration,
    getDashboardConfigurationLoading,
    cardSummaryCount,
    cardSummaryCountLoading,
  } = useSelector(state => ({
    bookingsList: state?.GetBookingsList?.data,
    bookingsListLoading: state?.GetBookingsList?.loading,

    bookingDetails: state?.GetBookingDetails?.data,
    bookingDetailsLoading: state?.GetBookingDetails?.loading,

    bookingTypeData: state.GetBookingTypeForGlobalSearch.data,
    bookingTypeLoading: state.GetBookingTypeForGlobalSearch.loading,

    getDashboardConfiguration: state.GetDashboardConfiguration.data,
    getDashboardConfigurationLoading: state.GetDashboardConfiguration.loading,

    cardSummaryCount: state.GetCardSummary.data,
    cardSummaryCountLoading: state.GetCardSummary.loading,
  }));

  const {
    assignToMeResponse,
    assignChauffeurResponse,
    assignVendorResponse,
    cancelBookingByAdminResponse,
    cancelBookingByVendorResponse,
    confirmBookingByVendorResponse,
    modifyBooking,
    approvalAction,
    completeBookingResponse,
    raiseDispute,
    bulkConfirmBookingByVendorResponse,
    validateOTP,
    sendNotification,
    rejectSlot,
  } = useSelector(state => ({
    assignToMeResponse: state?.BookingAssignToMe?.data,
    assignChauffeurResponse: state?.AssignChauffeur?.data,
    assignVendorResponse: state?.AssignVendor?.data,
    cancelBookingByAdminResponse: state?.CancelBookingByAdmin?.data,
    cancelBookingByVendorResponse: state?.CancelBookingByVendor?.data,
    confirmBookingByVendorResponse: state?.ConfirmBookingByVendor?.data,
    modifyBooking: state?.ModifyBooking?.data,
    approvalAction: state?.ApprovalActionBooking?.data,
    completeBookingResponse: state?.CompleteBooking?.data,
    raiseDispute: state?.RaiseDispute?.data,
    bulkConfirmBookingByVendorResponse: state?.BulkBookingConfirmationByVendor?.data,
    validateOTP: state?.ValidateOTP?.data,
    sendNotification: state?.SendNotificationByAdmin?.data,
    rejectSlot: state?.RejectSlot?.data,
  }));

  useEffect(() => {
    if (
      assignToMeResponse !== null ||
      assignChauffeurResponse != null ||
      assignVendorResponse !== null ||
      cancelBookingByAdminResponse !== null ||
      cancelBookingByVendorResponse !== null ||
      confirmBookingByVendorResponse !== null ||
      modifyBooking !== null ||
      approvalAction !== null ||
      completeBookingResponse !== null ||
      raiseDispute !== null ||
      bulkConfirmBookingByVendorResponse !== null ||
      validateOTP !== null ||
      sendNotification !== null ||
      rejectSlot !== null
    ) {
      dispatch({
        type: GET_BOOKINGS_LIST,
        payload: {
          urlParams: {
            page_size: limit,
            page_index: Number(skip) - 1,
            card_name: appliedName,
            is_notification_listing: true,
            is_show_unassigned_bookings: false,
          },
          params: {
            card_type: appliedType,
          },
        },
      });

      dispatch({
        type: BOOKING_ASSIGN_TO_ME_EMPTY,
      });
      dispatch({
        type: ASSIGN_CHAUFFEUR_EMPTY,
      });
      dispatch({
        type: ASSIGN_VENDOR_EMPTY,
      });
      dispatch({
        type: CANCEL_BOOKING_BY_ADMIN_EMPTY,
      });
      dispatch({
        type: CANCEL_BOOKING_BY_VENDOR_EMPTY,
      });
      dispatch({
        type: CONFIRM_BOOKING_BY_VENDOR_EMPTY,
      });

      dispatch({
        type: GET_BOOKING_DETAILS_EMPTY,
      });

      dispatch({
        type: COMPLETE_BOOKING_EMPTY,
      });

      dispatch({
        type: BULK_CONFIRM_BOOKING_BY_VENDOR_EMPTY,
      });

      dispatch({
        type: GET_DASHBOARD_CONFIGURATION,
      });

      dispatch({
        type: REJECT_SLOT_EMPTY,
      });

      dispatch({
        type: SEND_NOTIFICATION_EMPTY,
      });

      setCurrentSelectedBooking(null);
      setCurrentActiveBookingAction(null);
    }
  }, [
    assignToMeResponse,
    assignChauffeurResponse,
    assignVendorResponse,
    cancelBookingByAdminResponse,
    cancelBookingByVendorResponse,
    confirmBookingByVendorResponse,
    modifyBooking,
    approvalAction,
    completeBookingResponse,
    raiseDispute,
    bulkConfirmBookingByVendorResponse,
    validateOTP,
    sendNotification,
    rejectSlot,
  ]);

  useEffect(() => {
    if (getDashboardConfiguration !== null) {
      const modules = getDashboardConfiguration?.modules || {};
      const [onlyModuleKey] = Object.keys(modules); // get the only key
      setWorkflowStateFilters(getDashboardConfiguration?.modules?.[onlyModuleKey]?.notificationWorkflowStateCards ?? []);
    }
  }, [getDashboardConfiguration]);

  useEffect(() => {
    if (getDashboardConfiguration === null) {
      dispatch({
        type: GET_DASHBOARD_CONFIGURATION,
      });
    }
  }, []);

  useEffect(() => {
    if (workflowStateFilters?.length > 0) {
      const activeCard = workflowStateFilters?.find(item => item?.isDefault === true);
      updateURLParams({ skip: skip, limit: limit, appliedName: activeCard?.cardName, appliedType: activeCard?.cardType });

      dispatch({
        type: GET_CARD_SUMMARY,
        payload: {
          cards: workflowStateFilters?.map(item => {
            return {
              name: item?.cardName,
              type: item?.cardType,
            };
          }),
          is_notification_listing: true,
        },
      });
    }
  }, [workflowStateFilters]);

  useEffect(() => {
    if (appliedName !== `` && appliedType !== ``) {
      dispatch({
        type: GET_BOOKINGS_LIST,
        payload: {
          urlParams: {
            page_size: limit,
            page_index: Number(skip) - 1,
            card_name: appliedName,
            is_notification_listing: true,
            is_show_unassigned_bookings: false,
          },
          params: {
            card_type: appliedType,
          },
        },
      });
    }
  }, [skip, limit, appliedName, appliedType]);

  useEffect(() => {
    setCurrentPageNumber(Number(skip) - 1);
  }, [skip]);

  useEffect(() => {
    setRowsPerPage(Number(limit));
  }, [limit]);

  useEffect(() => {
    if (currentSelectedBooking) {
      dispatch({
        type: GET_BOOKING_DETAILS,
        payload: {
          params: {
            booking_id: currentSelectedBooking?.[0]?.id,
          },
        },
      });
    }
  }, [currentSelectedBooking]);

  useEffect(() => {
    if (bookingTypeData === null) {
      dispatch({
        type: GET_BOOKING_TYPE_FOR_GLOBAL_SEARCH,
      });
    }
  }, [bookingTypeData]);

  const updateURLParams = newParams => {
    const currentParams = queryString.parse(location.search);

    const updatedParams = {
      ...currentParams,
      ...newParams,
    };

    const newUrl = queryString.stringify(updatedParams);

    history.push({
      pathname: location.pathname,
      search: `?${newUrl}`,
    });
  };

  /* ---------------------------- BREADCRUMB HANDLER ---------------------------- */
  const breadcrumNavigationHandler = title => {
    if (title === `Dashboard`) {
      history.push(`/dashboard`);
    } else if (title === `Airport Dashboard`) {
      if (Constant?.userTypes?.VENDOR_USER_V2 === Number(localStorage.getItem('userType'))) {
        history.push(`/v2/vendor-dashboard`);
      } else if (Constant?.userTypes?.ADMIN_USER_V2 === Number(localStorage.getItem('userType'))) {
        history.push(`/v2/dashboard`);
      }
    }
  };

  useEffect(() => {
    if (bookingsListLoading || bookingDetailsLoading || bookingTypeLoading) {
      setLoading(true);
    } else {
      setLoading(false);
    }
  }, [bookingsListLoading, bookingDetailsLoading, bookingTypeLoading]);

  console.log('bookingsList', bookingsList);

  return (
    <div className="page-content">
      {loading && <Loader zIndex={true} />}

      {/* {
        <BookingModals
          currentSelectedBooking={currentSelectedBooking}
          currentActiveBookingAction={currentActiveBookingAction}
          setCurrentActiveBookingAction={setCurrentActiveBookingAction}
        />
      } */}

      {currentSelectedBooking?.[0]?.bookingType === `airport_transfers` && (
        <AirportTransferActionablesModals
          currentSelectedBooking={currentSelectedBooking}
          currentActiveBookingAction={currentActiveBookingAction}
          setCurrentActiveBookingAction={setCurrentActiveBookingAction}
          isMultiSelectable={false}
          approvalRequestType={null}
          bookingDetails={bookingDetails}
        />
      )}

      {currentSelectedBooking?.[0]?.bookingType === `golf` && (
        <GolfActionableModals
          currentSelectedBooking={currentSelectedBooking}
          currentActiveBookingAction={currentActiveBookingAction}
          setCurrentActiveBookingAction={setCurrentActiveBookingAction}
          isMultiSelectable={false}
          approvalRequestType={null}
          bookingDetails={bookingDetails}
        />
      )}

      <Container fluid className="position-relative">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex gap-1 align-items-center">
            <BreadcrumbTrail
              title={Constant?.userTypes?.VENDOR_USER_V2 === parseInt(localStorage.getItem('userType')) ? `Notifications` : `Search Result`}
              navigationby={breadcrumNavigationHandler}
              navigation={[`Dashboard`, 'My Bookings']}
              // isShowDate={true}
            />
          </div>
        </div>

        <>
          <StatusFilter
            statusFilters={workflowStateFilters}
            appliedStatusFilter={appliedName}
            updateURLParams={updateURLParams}
            setCurrentSelectedBooking={setCurrentSelectedBooking}
            setCurrentActiveBookingAction={setCurrentActiveBookingAction}
            setWorkflowDisplayName={setWorkflowDisplayName}
            cardSummaryCount={cardSummaryCount}
            setShouldHaveClearSelection={setShouldHaveClearSelection}
            setSecondaryFiltersList={setSecondaryFiltersList}
            setAssignedToMeFilter={setAssignedToMeFilter}
          />

          <DataViews
            data={bookingsList}
            updateURLParams={updateURLParams}
            skip={currentPageNumber}
            limit={rowsPerPage}
            selectedBooking={currentSelectedBooking}
            setCurrentSelectedBooking={setCurrentSelectedBooking}
            setCurrentActiveBookingAction={setCurrentActiveBookingAction}
            titleText={'All Results'}
            bookingType="Approval Action"
            isMultiSelectable={isMultiSelectable}
            setIsMultiSelectable={setIsMultiSelectable}
          />

          {bookingDetails && (
            <Summary
              details={bookingDetails}
              currentSelectedBooking={currentSelectedBooking?.[0]}
              setCurrentSelectedBooking={setCurrentSelectedBooking}
              setCurrentActiveBookingAction={setCurrentActiveBookingAction}
            />
          )}
        </>
      </Container>
    </div>
  );
};

export default Notification;
